/**
 * 予測結果を保持するクラス
 */
export default class PredictResult {
    /**
     * 行番号
     */
    private _index: any;

    /**
     * 確率
     */
    private _probability: any;

    /**
     * 予測結果
     */
    private _predict: any;

    /**
     * コンストラクタ
     * @param index 行番号
     * @param probability 確率
     * @param predict 予測結果
     */
    constructor(index: any, probability: any, predict: any) {
        this._index = index;
        this._probability = probability;
        this._predict = predict;
    }

    /**
     * getter 行番号取得
     */
    public get index(): any {
        return this._index;
    }

    /**
     * getter 確率
     */
    public get probability(): any {
        return this._probability;
    }

    /**
     * 予測結果
     */
    public get predict(): any {
        return this._predict;
    }
}
